import { colors } from '../components/Theme/WebTheme';

// Consistent status colors for subscription system
export const getStatusColor = (status) => {
  const statusLower = status?.toLowerCase();

  switch (statusLower) {
    case 'active':
      return '#4CAF50'; // Green
    case 'pending':
      return '#FF9800'; // Orange
    case 'payment_pending':
      return '#2196F3'; // Blue
    case 'expired':
      return '#f44336'; // Red
    case 'cancelled':
    case 'canceled':
      return '#9E9E9E'; // Grey
    case 'success':
      return '#4CAF50'; // Green (for transactions)
    case 'failed':
      return '#f44336'; // Red (for transactions)
    case 'admin_change':
      return '#4CAF50'; // Green (admin action)
    case 'user_change':
      return '#2196F3'; // Blue (user action)
    case 'suspended':
      return '#FF9800'; // Orange
    case 'inactive':
      return '#9E9E9E'; // Grey
    case 'refunded':
      return '#4CAF50'; // Green
    case 'partial_refund':
      return '#FF9800'; // Orange
    case 'cancelled_by_user':
      return '#9E9E9E'; // Grey
    case 'cancelled_by_admin':
      return '#9E9E9E'; // Grey
    case 'expired_by_user':
      return '#f44336'; // Red
    case 'expired_by_admin':
      return '#f44336'; // Red
    case 'expired_by_system':
      return '#f44336'; // Red
    case 'admin_payment':
      return '#4CAF50'; // Green
    case 'user_payment':
      return '#2196F3'; // Blue
    case 'offline':
      return '#9E9E9E'; // Grey
    case 'subscription_active':
      return '#4CAF50'; // Green
    case 'subscription_pending':
      return '#FF9800'; // Orange
    case 'subscription_expired':
      return '#f44336'; // Red
    case 'subscription_cancelled':
      return '#9E9E9E'; // Grey
    case 'subscription_created':
      return '#4CAF50'; // Green
    case 'status_update':
      return '#2196F3'; // Blue
    case 'admin_action':
      return '#4CAF50'; // Green
    case 'auto_free_subscription_created':
      return '#4CAF50'; // Green
    default:
      return '#9E9E9E'; // Grey (default)
  }
};

// Get status background color (lighter version for chips)
export const getStatusBackgroundColor = (status) => {
  const statusLower = status?.toLowerCase();

  // Handle invalid statuses
  if (statusLower === 'admin_update') {
    return '#e8f5e8'; // Light green (treat as success)
  }

  switch (statusLower) {
    case 'active':
      return '#e8f5e8'; // Light green
    case 'pending':
      return '#fff3e0'; // Light orange
    case 'payment_pending':
      return '#e3f2fd'; // Light blue
    case 'expired':
      return '#ffebee'; // Light red
    case 'cancelled':
    case 'canceled':
      return '#f5f5f5'; // Light grey
    case 'success':
      return '#e8f5e8'; // Light green
    case 'failed':
      return '#ffebee'; // Light red
    case 'admin_change':
      return '#e8f5e8'; // Light green (admin action)
    case 'user_change':
      return '#e3f2fd'; // Light blue (user action)
    case 'suspended':
      return '#fff3e0'; // Light orange
    case 'inactive':
      return '#f5f5f5'; // Light grey
    case 'refunded':
      return '#e8f5e8'; // Light green
    case 'partial_refund':
      return '#fff3e0'; // Light orange
    case 'cancelled_by_user':
      return '#f5f5f5'; // Light grey
    case 'cancelled_by_admin':
      return '#f5f5f5'; // Light grey
    case 'expired_by_user':
      return '#ffebee'; // Light red
    case 'expired_by_admin':
      return '#ffebee'; // Light red
    case 'expired_by_system':
      return '#ffebee'; // Light red
    case 'admin_payment':
      return '#e8f5e8'; // Light green
    case 'user_payment':
      return '#e3f2fd'; // Light blue
    case 'offline':
      return '#f5f5f5'; // Light grey
    case 'subscription_active':
      return '#e8f5e8'; // Light green
    case 'subscription_pending':
      return '#fff3e0'; // Light orange
    case 'subscription_expired':
      return '#ffebee'; // Light red
    case 'subscription_cancelled':
      return '#f5f5f5'; // Light grey
    case 'subscription_created':
      return '#e8f5e8'; // Light green
    case 'status_update':
      return '#e3f2fd'; // Light blue
    case 'admin_action':
      return '#e8f5e8'; // Light green
    case 'auto_free_subscription_created':
      return '#e8f5e8'; // Light green
    default:
      return '#f5f5f5'; // Light grey
  }
};

// Get status text color
export const getStatusTextColor = (status) => {
  const statusLower = status?.toLowerCase();

  // Handle invalid statuses
  if (statusLower === 'admin_update') {
    return '#2e7d32'; // Dark green (treat as success)
  }

  switch (statusLower) {
    case 'active':
      return '#2e7d32'; // Dark green
    case 'pending':
      return '#e65100'; // Dark orange
    case 'payment_pending':
      return '#1565c0'; // Dark blue
    case 'expired':
      return '#c62828'; // Dark red
    case 'cancelled':
    case 'canceled':
      return '#424242'; // Dark grey
    case 'success':
      return '#2e7d32'; // Dark green
    case 'failed':
      return '#c62828'; // Dark red
    case 'admin_change':
      return '#2e7d32'; // Dark green (admin action)
    case 'user_change':
      return '#1565c0'; // Dark blue (user action)
    case 'suspended':
      return '#e65100'; // Dark orange
    case 'inactive':
      return '#424242'; // Dark grey
    case 'refunded':
      return '#2e7d32'; // Dark green
    case 'partial_refund':
      return '#e65100'; // Dark orange
    case 'cancelled_by_user':
      return '#424242'; // Dark grey
    case 'cancelled_by_admin':
      return '#424242'; // Dark grey
    case 'expired_by_user':
      return '#c62828'; // Dark red
    case 'expired_by_admin':
      return '#c62828'; // Dark red
    case 'expired_by_system':
      return '#c62828'; // Dark red
    case 'admin_payment':
      return '#2e7d32'; // Dark green
    case 'user_payment':
      return '#1565c0'; // Dark blue
    case 'offline':
      return '#424242'; // Dark grey
    case 'subscription_active':
      return '#2e7d32'; // Dark green
    case 'subscription_pending':
      return '#e65100'; // Dark orange
    case 'subscription_expired':
      return '#c62828'; // Dark red
    case 'subscription_cancelled':
      return '#424242'; // Dark grey
    case 'subscription_created':
      return '#2e7d32'; // Dark green
    case 'status_update':
      return '#1565c0'; // Dark blue
    case 'admin_action':
      return '#2e7d32'; // Dark green
    case 'auto_free_subscription_created':
      return '#2e7d32'; // Dark green
    default:
      return '#424242'; // Dark grey
  }
};

// Format status for display
export const formatStatus = (status, t) => {
  const statusLower = status?.toLowerCase();

  // Filter out invalid statuses
  if (statusLower === 'admin_update') {
    return t('success'); // Treat admin_update as success for display
  }

  switch (statusLower) {
    case 'active':
      return t ? t('active') : 'Active';
    case 'pending':
      return t ? t('pending') : 'Pending';
    case 'payment_pending':
      return t ? t('payment_pending') : 'Payment Pending';
    case 'expired':
      return t ? t('expired') : 'Expired';
    case 'cancelled':
    case 'canceled':
      return t ? t('cancelled') : 'Cancelled';
    case 'success':
      // Map 'success' to 'active' for display consistency
      return t ? t('active') : 'Active';
    case 'failed':
      return t ? t('failed') : 'Failed';
    case 'admin_change':
      return t ? t('changed_by_admin') : 'Changed by Admin';
    case 'user_change':
      return t ? t('changed_by_user') : 'Changed by User';
    case 'suspended':
      return t ? t('suspended') : 'Suspended';
    case 'inactive':
      return t ? t('inactive') : 'Inactive';
    case 'refunded':
      return t ? t('refunded') : 'Refunded';
    case 'partial_refund':
      return t ? t('partial_refund') : 'Partial Refund';
    case 'cancelled_by_user':
      return t ? t('cancelled_by_user') : 'Cancelled by User';
    case 'cancelled_by_admin':
      return t ? t('cancelled_by_admin') : 'Cancelled by Admin';
    case 'expired_by_user':
      return t ? t('expired_by_user') : 'Expired by User';
    case 'expired_by_admin':
      return t ? t('expired_by_admin') : 'Expired by Admin';
    case 'expired_by_system':
      return t ? t('expired_by_system') : 'Expired by System';
    case 'admin_payment':
      return t ? t('admin_payment') : 'Admin Payment';
    case 'user_payment':
      return t ? t('user_payment') : 'User Payment';
    case 'offline':
      return t ? t('offline') : 'Offline';
    case 'subscription_active':
      return t ? t('subscription_active') : 'Subscription Active';
    case 'subscription_pending':
      return t ? t('subscription_pending') : 'Subscription Pending';
    case 'subscription_expired':
      return t ? t('subscription_expired') : 'Subscription Expired';
    case 'subscription_cancelled':
      return t ? t('subscription_cancelled') : 'Subscription Cancelled';
    case 'subscription_created':
      return t ? t('subscription_created') : 'Subscription Created';
    case 'status_update':
      return t ? t('status_update') : 'Status Update';
    case 'admin_action':
      return t ? t('admin_action') : 'Admin Action';
    case 'auto_free_subscription_created':
      return t ? t('auto_free_subscription_created') : 'Auto Free Subscription Created';
    case 'limit_reached':
      return t ? t('limit_reached') : 'Limit Reached';
    default:
      // If status is null/undefined, return "Unknown"
      if (!status) {
        return t ? t('unknown') : 'Unknown';
      }
      // If status exists but not recognized, return the original status
      return status;
  }
};

// Check if status is active
export const isActiveStatus = (status) => {
  const statusLower = status?.toLowerCase();
  return statusLower === 'active';
};

// Check if status is pending
export const isPendingStatus = (status) => {
  const statusLower = status?.toLowerCase();
  return statusLower === 'pending' || statusLower === 'payment_pending';
};

// Check if status is completed/final
export const isCompletedStatus = (status) => {
  const statusLower = status?.toLowerCase();
  return statusLower === 'active' || statusLower === 'expired' || statusLower === 'cancelled' || statusLower === 'canceled';
};

// Format payment method for display
export const formatPaymentMethod = (paymentMethod, t) => {
  const methodLower = paymentMethod?.toLowerCase();

  switch (methodLower) {
    case 'admin_cancel':
      return t ? t('cancelled_by_admin') : 'Cancelled by Admin';
    case 'user_cancel':
      return t ? t('cancelled_by_user') : 'Cancelled by User';
    case 'admin_change':
      return t ? t('changed_by_admin') : 'Changed by Admin';
    case 'free':
      return t ? t('free') : 'Free';
    case 'wallet':
      return t ? t('wallet') : 'Wallet';
    case 'cash':
      return t ? t('cash') : 'Cash';
    case 'yappi':
      return t ? t('yappi') : 'Yappi';
    case 'bank_transfer':
      return t ? t('bank_transfer') : 'Bank Transfer';
    case 'stripe':
      return t ? t('stripe') : 'Stripe';
    case 'paypal':
      return t ? t('paypal') : 'PayPal';
    default:
      return paymentMethod || 'Unknown';
  }
};

// Format adminNote for display with translation
export const formatAdminNote = (adminNote, t) => {

  console.log('adminNote =======> ', adminNote);

  if (!adminNote) return '-';
  
  // Check if adminNote follows the translation pattern
  if (adminNote.includes(':')) {
    const parts = adminNote.split(':');
    
    // Handle status_changed_from_to pattern
    if (parts[0] === 'status_changed_from_to' && parts.length === 3) {
      const fromStatus = formatStatus(parts[1], t);
      const toStatus = formatStatus(parts[2], t);
      return t('status_changed_from_to')
        .replace('{fromStatus}', fromStatus)
        .replace('{toStatus}', toStatus);
    }
    
    // Handle other translation keys
    if (parts.length === 1 && t(parts[0])) {
      return t(parts[0]);
    }
  }
  
  // Check if it's a simple translation key
  if (t && t(adminNote) !== adminNote) {
    return t(adminNote);
  }
  
  // Return original text if no translation pattern matches
  return adminNote;
}; 